import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import {
  GridParams,
  GridPostParams,
} from 'common/models/utility-models/list-utility.model';
// import { environment } from 'src/environment';
import { environment } from 'src/environments/environment';

import { GridDataService } from '../../base-data-services/grid-data.service';
import { CompanyLocationModel } from 'common/models/page-models/internship-company/company-location/company-location-data.model';
import { CompanyLocationListingModel, CompanyLocationGridParams } from 'common/models/page-models/internship-company/company-location/company-location-grid.model';

@Injectable({
  providedIn: 'root',
})
export class CompanyLocationGridDataService extends GridDataService<
  CompanyLocationListingModel,
  CompanyLocationModel
> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.internshipCompanyLocation, http, ss);
  }

  createInstance(): CompanyLocationListingModel {
    return new CompanyLocationListingModel();
  }

  override getGridParams(param): GridPostParams {
    const params = new CompanyLocationGridParams();
    // params.internshipCompanyId = param.id;
    params.internshipCompanyId = param.id
      ? param.id
      : param.internshipCompanyId;
    return params;
  }

  override getDeleteUrl() {
    return environment.apiUrl + API_URL.internshipCompanyLocationDelete;
  }

  override getDeletePayload(data) {
    // console.log(data,'getDeletePayload')
    let payload;
    if (data.id) {
      payload = {
        // multi_check: data.id,
        id: data.id,
      };
    } else {
      payload = data;
    }
    return payload;
  }
}
